import { createApp, getCurrentInstance } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/assets/styles/index.scss' // global css
import '@/assets/styles/fs.scss' // fs css
import '@/assets/styles/element-plus.scss' // element-plus.scss
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import router from './router'
import './permission' // permission control
import store from './store'
import plugins from './plugins' // plugins
import webSocket from '@/utils/webSocket'

// 自定义表格工具组件
import RightToolbar from '@/components/RightToolbar'
// 分页组件
import Pagination from '@/components/Pagination'
// 字典标签组件
import DictTag from '@/components/DictTag'
// 字典数据组件
import DictData from '@/components/DictData'
// 富文本组件
import Editor from "@/components/Editor"

import SelectTable from "@/components/SelectTable"

import zhCn from "element-plus/es/locale/lang/zh-cn";
import { parseTime, resetForm, addDateRange, selectDictLabel, selectDictLabels, handleTree, base64ToBlob } from "@/utils/fs";
import { getDicts } from "@/api/system/dict/data";


const app = createApp(App);
app.use(ElementPlus, {
  //改中文
    locale: zhCn
});
app.use(router);
app.use(store)
app.use(plugins)
app.use(DictData)
app.directive('hasPermi', 
  { 
    mounted(el, binding, vNode) {
      const { value } = binding
      const all_permission = "*:*:*";
      const permissions = store.getters && store.getters.permissions
      if (value && value instanceof Array && value.length > 0) {
          const permissionFlag = value
      
          const hasPermissions = permissions.some(permission => {
              return all_permission === permission || permissionFlag.includes(permission)
          })
  
          if (!hasPermissions) {
              el.parentNode && el.parentNode.removeChild(el)
          }
      } else {
          throw new Error(`请设置操作权限标签值`)
      }
    }
  }
)

// 全局挂载和注册 element-plus 的所有 icon
app.config.globalProperties.$icons = []
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.config.globalProperties.$icons.push(key);
  app.component(key, component)
}
// 全局方法挂载
app.config.globalProperties.parseTime = parseTime
app.config.globalProperties.resetForm = resetForm
app.config.globalProperties.handleTree = handleTree
app.config.globalProperties.getDicts = getDicts
app.config.globalProperties.selectDictLabel = selectDictLabel
app.config.globalProperties.selectDictLabels = selectDictLabels
app.config.globalProperties.webSocket = webSocket
app.config.globalProperties.base64ToBlob = base64ToBlob
app.config.globalProperties.addDateRange = addDateRange

// 全局组件挂载
app.component('RightToolbar', RightToolbar)
app.component('Pagination', Pagination)
app.component('DictTag', DictTag)
app.component('Editor', Editor)
app.component('SelectTable', SelectTable)

// DictData.install()
app.mount('#app')

